import "./style.scss";

function CentralLayout({ children }) {
  return <div className="dsearch-central-layout">{children}</div>;
}

export default CentralLayout;
